module.exports = __webpack_public_path__ + "img/dart-1.b4f9ad52.jpg";